import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as Sentry from "@sentry/react";
import { AxiosError } from "axios";

Sentry.init({
  dsn: "https://d271e07e92a297baaeca1e698d6c89f9@o4506630659375104.ingest.us.sentry.io/4507174762774528",
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  environment: process.env.DEPLOY,
  enabled: process.env.DEPLOY === "prod",
  beforeSend(event, hint) {
    const axiosArror = hint.originalException as AxiosError;

    if (axiosArror.isAxiosError) return null;

    return event;
  },

  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.querySelector("#root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
